module.exports = __webpack_public_path__ + "img/discord.cdac36b6.svg";